import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-top-scroll-notice-icon",
  "use": "icon-top-scroll-notice-icon-usage",
  "viewBox": "0 0 1137.778 1024",
  "content": "<symbol class=\"t-icon t-icon-sound-filled\" viewBox=\"0 0 1137.778 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-top-scroll-notice-icon\"><path fill-rule=\"evenodd\" d=\"M739.556 0v1024L341.333 768H0V256h341.333L739.556 0Zm113.777 170.667c162.293 32.271 284.445 172.828 284.445 341.333 0 168.505-122.152 309.062-284.445 341.333V739.556C938.667 711.11 1024 654.222 1024 512s-85.333-199.111-170.667-227.556V170.667Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol